import fr from 'facet-rest';
import BaseOverride from 'Views/Page/Content/Templates/WhatIfTemplate/BaseOverride';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import DolDisclaimerAlert from './DolDisclaimerAlert';
import QualifiedWithdrawalTooltip from './QualifiedWithdrawalTooltip';

export default fr.metaOverride({ base: BaseOverride })
  .nameOverride('dolDisclaimer', { _component: () => DolDisclaimerAlert }, { ordinal: 200 })
  .nameOverride('fullBalanceDisclaimer', { _component: () => DolDisclaimerAlert }, { ordinal: 200 })
  .nameOverride('fullBalanceDisclaimer2', { _component: () => DolDisclaimerAlert }, { ordinal: 200 })
  .nameOverride('bdrDisclaimer', { _component: () => DolDisclaimerAlert }, { ordinal: 200 })
  .nameOverride('isQualifiedWithdrawal', { _component: () => QualifiedWithdrawalTooltip }, { ordinal: 200 })
  .nameOverride('justificationDetails', { _customProps: { multiline: true, rows: 5 } }, overrideReadOnly);
